export class Step6 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step5';
    getnbmois = 'form.mapa_in.getnbmois';
    getnbjours = 'form.mapa_in.getnbjours';
    getspan5 = 'form.mapa_in.getspan5';
    getspan6 = 'form.mapa_in.getspan6';
    getdateacompterdu = 'form.mapa_in.getdateacompterdu';
    getdatejusquau = 'form.mapa_in.getdatejusquau';
    getdatedebutprestation = 'form.mapa_in.getdatedebutprestation';
    getdatedebuttravaux = 'form.mapa_in.getdatedebuttravaux';
    gettxtlibre = 'form.mapa_in.gettxtlibre';

}
